/* template */
<template minapp="mpx" xlang="wxml"><div><div class="seat-container"><div class="segment" v-if="(isTransfer)"><span>第</span><span>{{ seatInfoIndex + 1 }}</span><span>程</span></div><div :class='"es-seat-information"' :style="[(refactorTicketData.length <= 3 ? 'justify-content:space-between':'')] | transRpxStyle" v-if="(refactorTicketData)"><mpx-view :class='((item?.seat_type_name === selectSeatInfo?.seat_type_name ? "select" : "not-select")+" "+(refactorTicketData.length <= 3 && "bbigpadding")+" "+(isTransfer && "small-card"))' v-for="(item, index) in (refactorTicketData)" :key="item.index" @tap.stop="selectSeat(item)" :style="[(seatStyle)] | transRpxStyle" class="es-card"><div :class="({ 'select-seat-type-name': item?.seat_type_name === selectSeatInfo?.seat_type_name , 'gray': newTransfer && item.ticket_num === '无票'})" class="es-seat-type-name">{{ item.seat_type_name }}<div class="student-tag" v-if="(item.is_student && isStudentType)">学</div></div><mpx-view @tap="showTicketDetail(item)" class="ticket-info"><div :class="({'gray': newTransfer && item.ticket_num === '无票'})" class="es-ticket-price"><span class="es-ticket-price-copywritting"><span class="appointment-tag" v-if="(item.is_student && isStudentType)">约</span>￥{{ item.show_price }}</span><svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" fill="none" version="1.1" width="7" height="4" viewBox="0 0 7 4" class="triangle-icon" v-if="(item.showSleeperSeat)"><g transform="matrix(1,-2.2348338291067193e-8,2.2348338291067193e-8,-1,-8.939335666040634e-8,8.000000312876736)"><path d="M4.00172,4.573392156438368L6.03254,6.894330156438368C6.40971,7.3253901564383685,6.10359,8.000000156438368,5.53082,8.000000156438368L1.46918,8.000000156438368C0.896406,8.000000156438368,0.590288,7.3253901564383685,0.967461,6.894330156438368L2.99828,4.573392156438368C3.26389,4.269840156438368,3.73611,4.269840156438368,4.00172,4.573392156438368" fill-opacity="1"/></g></svg></div><div :class="({'grab-remainder':item.ticket_num === '无票' && !fromChangeTicket && !isPreScramble && !isTransfer, 'gray': newTransfer && item.ticket_num === '无票'})" class="es-ticket-remainder">{{
                isPreScramble
                  ? '预约'
                  : item.ticket_num === '无票' && !fromChangeTicket && !isTransfer
                  ? '抢票'
                  : item.ticket_num
              }}</div></mpx-view><div class="select-icon" v-if="(item?.seat_type_name === selectSeatInfo?.seat_type_name && !(newTransfer && item.ticket_num === '无票'))"></div><div class="not-select-icon" v-else-if="(item?.seat_type_name !== selectSeatInfo?.seat_type_name && !(newTransfer && item.ticket_num === '无票'))"></div></mpx-view></div></div></div></template>

/* styles */
<style lang="stylus" scoped mpxStyleOptions='{"mid":"m17fa8b3c"}'>
  @import '~@/mixins/stylus/color.styl'

  .student-notice
    font-size 12px
    font-weight 400
    color #999999
    margin 12px 6px 12px 12px
    display flex
    justify-content space-between
    .title
      font-family PingFangSC-Medium
      font-size 14px
      color #3D3D3D
      margin-bottom 4px
      position relative
      &::after
        position absolute
        content ''
        left 236px
        top 5px
        width 6.67px
        height 10px
        background-image url('https://dpubstatic.udache.com/static/dpubimg/j80vbZo_EnySMVS9OP0aN.png')
        background-size contain
        background-repeat no-repeat
    .icon
      width 50.75px
      height 44.52px
      background-image url('https://dpubstatic.udache.com/static/dpubimg/ah7pEfzRHkBR58WDp6Zan.png')
      background-size cover
      background-repeat no-repeat
  .es-seat-information
    display flex
    justify-content flex-start
    flex-direction row
    overflow-x auto
    overflow-y hidden
    white-space nowrap
    flex-wrap nowrap
    flex-flow row
    flex 1
    margin-right -12px
    padding-right 12px
    .es-card
      flex-shrink 0
      position relative
      min-width 56px
      border-radius 10px
      border-bottom-right-radius 12px
      height 64px
      // border 1px solid #CCCCCC
      box-sizing border-box
      display flex
      flex-direction column
      align-items center
      justify-content center
      // overflow hidden
      &.small-card
        height 64px
      &:not(:last-child)
        margin-right 8px
      .es-seat-type-name
        line-height 15px
        font-family PingFangSC-Medium
        font-bold 500
        font-size 15px
        color #000000
        text-align center
        display flex
        flex-direction row
        justify-content center
        align-items center
      .gray 
        color #999
      // .select-seat-type-name
      // color #1473FF
      .student-tag
        font-size 9px
        line-height 12px
        background rgba(52, 187, 109, 0.1)
        font-family PingFangSC-Medium
        color #34BB6D
        width 12px
        height 12px
        margin-left 2px
        box-sizing border-box
        border 0.5px solid #34BB6D
        border-radius 2px
        text-align center
      .ticket-info
        display flex
        height 14px
        line-height 14px
        margin-top 5px
        font-size 12px
        font-family PingFangSC-Regular
        white-space nowrap
        .es-ticket-price
          font-family PingFangSC-Regular
          font-size 12px
          color #333
          white-space nowrap
          display flex
          align-items center
        .es-ticket-price-copywritting
          display inline-block
          .appointment-tag
            font-size 10px
            position relative
            top -1px
        .triangle-icon
          margin-left 2px
          fill #333
        .es-ticket-detail-icon
          height 4px
          width 6px
          background-size cover
          margin-left 1px
        .gray 
          color #999
        .es-ticket-remainder
          position relative
          margin-left 8px
          color #333
          &::after
            content ''
            height 8px
            border 0.5px solid rgba(153, 153, 153, 0.7)
            position absolute
            top 50%
            left -4px
            transform translateY(-50%)
        .grab-remainder
          color #FF4129
        .gray 
          color #999
    // .select
    // background #F3F8FF
    // color #000
    // .es-ticket-remainder
    // color #333
    .bbigpadding
      padding-left 0
      padding-right 0
  .pay-type-tips
    margin-top 8px
    background #F3F8FF
    border-radius 8px
    padding 8px 12px
    box-sizing border-box
    word-wrap break-word
    font-family PingFangSC-Regular
    font-size 12px
    color #3C5A86
    letter-spacing 0
    font-weight 400
  .select
    border 0.5px solid #FF6400
    .select-icon
      width 17.5px
      height 17.5px
      position absolute
      right 0
      bottom 0
      background url('https://ut-static.udache.com/webx/sfc/e7kf3fi4evCSgybsRlhzS.png') center no-repeat
      background-size cover
    .es-seat-type-name
      color #1473FF
  .not-select
    border 0.5px solid #CCCCCC
    .not-select-icon
      width 17.5px
      height 17.5px
      position absolute
      right 0
      bottom 0
      background url('https://ut-static.udache.com/webx/sfc/FDuZfNnktbQK1X57QbnbJ.png') center no-repeat
      background-size cover
  .seat-container
    display flex
    .segment
      display flex
      flex-direction column
      justify-content center
      align-items center
      padding 9px 6.5px
      font-size 10px
      color #666
      border-radius 6px
      margin-right 8px
      background #F2F6F9
</style>

/* json */
/* script */
<script>
  import processOption, { getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  const wxsModules = {}
  global.currentModuleId = "m17fa8b3c"
  global.currentSrcMode = "wx"
  /** script content **/
  require("./index.mpx.js?isComponent&outputPath=components%2Findex17fa8b3c%2Findex!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./index.mpx?ctorType=component&index=0&isComponent&mpx&outputPath=components%2Findex17fa8b3c%2Findex&type=script")
  const currentOption = global.__mpxOptionsMap["m17fa8b3c"]
  export default processOption(
    currentOption,
    "component",
    "",
    "components/index17fa8b3c/index",
    {},
    // @ts-ignore
    {},
    // @ts-ignore
    {'mpx-view':getComponent(require("@mpxjs/webpack-plugin/lib/runtime/components/web/mpx-view.vue?isComponent"), { __mpxBuiltIn: true })},
    undefined,
    {},
    undefined,
    getWxsMixin(wxsModules)
  )
</script>
